import { RefObject } from 'react';
import { VideoCropPosition } from '../../MainPlayer/types/Scene';

export enum SelectionElementType {
  CAPTIONS = 'CAPTIONS',
  SPEAKER_LABEL = 'SPEAKER_LABEL',
  SPEAKER_LABEL_TITLE = 'SPEAKER_LABEL_TITLE',
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  LOTTIE = 'LOTTIE',
  VIDEO_IN_COMPOSITE = 'VIDEO_IN_COMPOSITE'
}

export enum SelectionOutlineAction {
  SELECT = 'SELECT',
  DESELECT = 'DESELECT',
  UPDATE_POSITION = 'UPDATE_POSITION'
}

export type CaptionsSelectionElementData = { type: SelectionElementType.CAPTIONS };
export type SpeakerLabelSelectionElementData = { speakerId: string; type: SelectionElementType.SPEAKER_LABEL };
export type ImageOverlaySelectionElementData = { elementId: string; type: SelectionElementType.IMAGE };
export type TextSelectionElementData = { elementId: string; type: SelectionElementType.TEXT };
export type VideoOverlaySelectionElementData = { elementId: string; type: SelectionElementType.VIDEO };
export type CompositeVideoSelectionElementData = {
  elementId: string;
  type: SelectionElementType.VIDEO_IN_COMPOSITE;
  // TODO we can also use dataURL instead of passing the ref for the image. By pausing the video while selection is active.
  videoElementRef: RefObject<HTMLDivElement>;
  videoUrl?: string;
  compositeSegmentId: string;
  videoAspectRatio: number;
  cropInformation?: VideoCropPosition;
};
export type LottieOverlaySelectionElementData = { elementId: string; type: SelectionElementType.LOTTIE };
export type SelectionElementData =
  | CaptionsSelectionElementData
  | SpeakerLabelSelectionElementData
  | ImageOverlaySelectionElementData
  | TextSelectionElementData
  | VideoOverlaySelectionElementData
  | CompositeVideoSelectionElementData
  | LottieOverlaySelectionElementData;
